import _Dialog from "@mui/material/Dialog";
import _DialogActions from "@mui/material/DialogActions";
import _DialogContent from "@mui/material/DialogContent";
import _Box from "@mui/material/Box";
import _Typography from "@mui/material/Typography";
import _DialogTitle from "@mui/material/DialogTitle";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Trans } from 'react-i18next';
import { styled } from 'styled-components';
import { Button } from './button';
function CancelChallengeEditionDialog({
  ...props
}) {
  return /*#__PURE__*/React.createElement(_Dialog, _extends({
    fullWidth: true,
    maxWidth: "sm",
    onClose: () => props.handleClose()
  }, props, {
    sx: {
      '.MuiPaper-root': {
        borderRadius: 4
      }
    }
  }), /*#__PURE__*/React.createElement(_DialogTitle, {
    color: "#283859",
    fontSize: "1.5rem",
    fontWeight: "700",
    marginBottom: 2
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.challenge_post.form.leave_update"
  })), /*#__PURE__*/React.createElement(_DialogContent, null, /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 3
  }, /*#__PURE__*/React.createElement(_Typography, {
    variant: "body2"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.challenge_post.form.leave_without_saving"
  })))), /*#__PURE__*/React.createElement(_DialogActions, {
    sx: {
      padding: '0 24px 16px',
      gap: '8px'
    }
  }, /*#__PURE__*/React.createElement(StyledButton, {
    color: "primary",
    onClick: () => props.handleClose(),
    size: "large",
    variant: "outlined"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.actions.cancel"
  })), /*#__PURE__*/React.createElement(StyledButton, {
    disableElevation: true,
    color: "primary",
    onClick: () => props.handleClose(true),
    size: "large",
    variant: "contained"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "commons.actions.confirm"
  }))));
}
const StyledButton = styled(Button)`
  && {
    border-radius: 8px;
  }
`;
export default CancelChallengeEditionDialog;